module.exports = __webpack_public_path__ + "static/icon__crypto--multicolor--invert-6c29201518d75dbc6c6c6ff147a8ef2e.png";